module.exports = __webpack_public_path__ + "img/left.b6cf0f50.jpg";